/* eslint-disable */
<template>
  <div>
    <div class="container-fluid w-100 no-padding">
      <div class="row bg-primary-dark">
        <div class="col-md-8 mb-2 mt-2 align-middle d-flex flex-row">
          <h4 class="mr-4">Hizmet Fiyatları</h4>
          <select type="text" class="form-control" style="width: 250px;" 
            v-model="selectedListId" id="selectedListId" @change="onListIdChange">
            <option v-for="(list, index) in priceLists" :value="list.ID">{{list.NAME}}</option>
          </select>
        </div>
        <div class="col-md-4 mb-2 mt-2">
          <button class="btn btn-more-radius btn-success float-right mr-2" data-toggle="modal" data-target="#uetdsModal">Yeni Fiyat Ekle</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <v-wait for="unit-prices-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Veriler yükleniyor...</p>
              </div>
            </template>
            <table class="table table-bordered table-striped table-hover">
              <thead class="thead-light">
                <tr>
                  <th style="width: 32px;" scope="col">#</th>
                  <th style="width: 10%;" scope="col">KATEGORİ</th>
                  <th style="width: 20%;" scope="col">ÜRÜN / HİZMET</th>
                  <th style="width: 8%;" scope="col">HİZMET SÜRESİ</th>
                  <th style="width: 8%;" scope="col">BİRİM FİYAT (KDV HARİÇ)</th>
                  <th style="width: 8%;" scope="col">KDV ORANI</th>
                  <th style="width: 8%;" scope="col">BİRİM FİYAT (KDV DAHİL)</th>
                  <th style="width: 10%;" scope="col">KAYDEDEN</th>
                  <th style="width: 10%;" scope="col">GÜNCELLEME</th>
                  <th style="width: 15%;" scope="col">KOMUTLAR</th>
                </tr>
              </thead>
              <tbody class="tbody-margin">
                <template v-for="(unitPrice, index) in unitPrices">
                  <tr :key="'trow-first-' + unitPrice.index">
                    <td class="align-middle text-center">{{index + 1}}</td>
                    <td class="align-middle text-center">{{unitPrice.CATEGORY}}</td>
                    <td class="align-middle text-center">{{unitPrice.NAME}}</td>
                    <td class="align-middle text-center">{{formatPeriod(unitPrice.PERIOD)}}</td>
                    <td class="align-middle text-center">{{unitPrice.UNIT_PRICE ? unitPrice.UNIT_PRICE.toFixed(2) + ' ₺' : '—'}}</td>
                    <td class="align-middle text-center">{{unitPrice.KDV}}</td>
                    <td class="align-middle text-center">{{unitPrice.UNIT_PRICE ? calculateTotalPrice(unitPrice).toFixed(2) + ' ₺' : '—'}}</td>
                    <td class="align-middle text-center">{{unitPrice.PERSONEL_NAME}}</td>
                    <td class="align-middle text-center">{{calculateLastUpdateDate(unitPrice)}}</td>
                    <td class="align-middle">
                      <button class="btn btn-sm btn-more-radius btn-primary" data-toggle="modal"
                        data-target="#uetdsModal" @click="selectUnitPrice(index)">Güncelle</button>
                      <button class="btn btn-sm btn-more-radius btn-danger" data-toggle="modal" 
                        data-target="#uetdsDeleteConfirmation" @click="selectUnitPrice(index)">Sil</button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </v-wait>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="uetdsModal" tabindex="-1"
      role="dialog" aria-labelledby="uetdsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uetdsModalLabel">Kargo Kaydı Ekleyin/Güncelleyin</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="cargo-inserting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Hizmet fiyatı Kaydediliyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="unitPriceListId">FİYAT LİSTESİ</label>
                    <select type="text" class="form-control"
                      v-model="newUnitPrice.listId" id="unitPriceListId">
                      <option v-for="(list, index) in priceLists" :value="list.ID">{{list.NAME}}</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="customerTitle">KATEGORİ</label>
                    <input type="text" class="form-control" v-model="newUnitPrice.category" id="customerTitle">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="vehicleName">ÜRÜN / HİZMET</label>
                    <input type="text" class="form-control" v-model="newUnitPrice.name" id="vehicleName">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="vehicleId">HİZMET SÜRESİ</label>
                    <input type="text" class="form-control" v-model="newUnitPrice.period" id="vehicleId">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="wsUser">BİRİM FİYAT (KDV HARİÇ)</label>
                    <input type="text" class="form-control" v-model="newUnitPrice.unitPrice" id="wsUser">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="wsPassword">KDV</label>
                    <input type="text" class="form-control" :value="newUnitPrice.kdv" id="wsPassword">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="wsPassword">BİRİM FİYAT (KDV DAHİL)</label>
                    <input type="text" disabled class="form-control" :value="calculateTotalPrice2(newUnitPrice)" id="wsPassword">
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button v-if="getPersonelId == 3 || getPersonelId == 24" type="button" @click="addUnitPrice()" class="btn btn-success">Birim Fiyatı Ekle/Güncelle</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="uetdsDeleteConfirmation" tabindex="-1"
      role="dialog" aria-labelledby="uetdsDeleteConfirmationLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uetdsDeleteConfirmationLabel">Hizmet Kaydını Sil</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="cargo-deleting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Hizmet Kaydı Siliniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="unitPriceListId">FİYAT LİSTESİ</label>
                    <select type="text" class="form-control" disabled
                      :value="newUnitPrice.listId" id="unitPriceListId">
                      <option v-for="(list, index) in priceLists" :value="list.ID">{{list.NAME}}</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="customerTitle">KATEGORİ</label>
                    <input type="text" class="form-control" disabled :value="newUnitPrice.category" id="customerTitle">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="vehicleName">ÜRÜN / HİZMET</label>
                    <input type="text" class="form-control" disabled :value="newUnitPrice.name" id="vehicleName">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="vehicleId">HİZMET SÜRESİ</label>
                    <input type="text" class="form-control" disabled :value="newUnitPrice.period" id="vehicleId">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="wsUser">BİRİM FİYAT (KDV HARİÇ)</label>
                    <input type="text" class="form-control" disabled :value="newUnitPrice.unitPrice" id="wsUser">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="wsPassword">KDV</label>
                    <input type="text" class="form-control" disabled :value="newUnitPrice.kdv" id="wsPassword">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="wsPassword">BİRİM FİYAT (KDV DAHİL)</label>
                    <input type="text" disabled class="form-control" :value="calculateTotalPrice2(newUnitPrice)" id="wsPassword">
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button v-if="getPersonelId == 3 || getPersonelId == 24" type="button" @click="deleteUnitPrice()" class="btn btn-danger">Birim Fiyatı Sil</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'UnitPricesPage',
  components: {
    Datepicker
  },
  data () {
    return {
      messageText: '',
      selectedCargoId: 0,
      selectedCargo: {},
      newUnitPrice: {
        id: 0,
        category: '',
        name: '',
        unitPrice: 0,
        kdv: 20,
        listId: 1,
      },
      unitPrices: [],
      priceLists: [
        {
          ID: 1,
          NAME: 'Lenoi'
        },
        {
          ID: 2,
          NAME: 'Kıbrıs'
        },
        {
          ID: 3,
          NAME: 'Nokkon'
        },
        {
          ID: 4,
          NAME: 'Nizip Mustafa'
        }
      ],
      selectedListId: 1,
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      },
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY HH:mm');
    },
    formatPeriod(period) {
      if(period == null || period == undefined || period == '') {
        return '—'
      }

      return period + ' AY'
    },
    calculateLastUpdateDate(unitPrice) {
      if(unitPrice.MODIFIED_AT == null || unitPrice.MODIFIED_AT == undefined || unitPrice.MODIFIED_AT == '') {
        return moment(unitPrice.CREATED_AT).format('DD.MM.YYYY HH:mm');
      }

      return moment(unitPrice.MODIFIED_AT).format('DD.MM.YYYY HH:mm');
    },
    calculateTotalPrice(unitPrice) {
      if(unitPrice.UNIT_PRICE == null || unitPrice.UNIT_PRICE == undefined || unitPrice.UNIT_PRICE == '') {
        return '—'
      }

      return parseFloat(unitPrice.UNIT_PRICE) * (1 + unitPrice.KDV / 100);
    },
    calculateTotalPrice2(unitPrice) {
      if(unitPrice.unitPrice == null || unitPrice.unitPrice == undefined || unitPrice.unitPrice == '') {
        return '—'
      }

      return parseFloat(unitPrice.unitPrice) * (1 + unitPrice.kdv / 100);
    },
    onListIdChange() {
      this.getUnitPrices()
    },
    getUnitPrices() {
      this.$wait.start('unit-prices-loading');

      axios
      .get('/api/unitprices/list/' + this.selectedListId)
      .then(response => {
        this.unitPrices = response.data
        this.$wait.end('unit-prices-loading')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('unit-prices-loading')
      })
    },
    addUnitPrice() {
      this.$wait.start('unit-price-inserting');

      if(this.newUnitPrice.period == null || this.newUnitPrice.period == undefined || this.newUnitPrice.period == '') {
        this.newUnitPrice.period = null
      } else {
        this.newUnitPrice.period = parseInt(this.newUnitPrice.period)
      }

      if(this.newUnitPrice.unitPrice == null || this.newUnitPrice.unitPrice == undefined || this.newUnitPrice.unitPrice == '') {
        this.newUnitPrice.unitPrice = null
      } else {
        this.newUnitPrice.unitPrice = parseFloat(this.newUnitPrice.unitPrice)
      }

      if(this.newUnitPrice.kdv == null || this.newUnitPrice.kdv == undefined || this.newUnitPrice.kdv == '') {
        this.newUnitPrice.kdv = null
      } else {
        this.newUnitPrice.kdv = parseInt(this.newUnitPrice.kdv)
      }

      this.newUnitPrice.listId = parseInt(this.newUnitPrice.listId)

      console.log('unitPrice to be added/updated: ', this.newUnitPrice)

      axios
      .post('/api/unitprices', this.newUnitPrice)
      .then(response => {
        this.$wait.end('unit-price-inserting')
        this.getUnitPrices()
        this.newUnitPrice.id = 0
        this.newUnitPrice.category = ''
        this.newUnitPrice.name = ''
        this.newUnitPrice.unitPrice = 0
        this.newUnitPrice.kdv = 20
        this.newUnitPrice.period = null
        this.newUnitPrice.listId = 1
        $('#uetdsModal').modal('hide')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('unit-price-inserting')
      })
    },
    deleteUnitPrice() {      
      axios
      .delete('/api/unitprices/' + this.selectedUnitPriceId)
      .then(response => {
        this.$wait.end('unit-price-deleting')
        this.getUnitPrices()
        this.newUnitPrice.id = 0
        this.newUnitPrice.category = ''
        this.newUnitPrice.name = ''
        this.newUnitPrice.unitPrice = 0
        this.newUnitPrice.kdv = 20
        this.newUnitPrice.period = null
        this.newUnitPrice.listId = 1
        $('#uetdsDeleteConfirmation').modal('hide')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('unit-price-deleting')
      })
    },
    selectUnitPrice(index) {
      this.selectedUnitPriceId = this.unitPrices[index].ID
      this.selectedUnitPrice = this.unitPrices[index]

      this.newUnitPrice.id = this.selectedUnitPrice.ID
      this.newUnitPrice.category = this.selectedUnitPrice.CATEGORY
      this.newUnitPrice.name = this.selectedUnitPrice.NAME
      this.newUnitPrice.unitPrice = this.selectedUnitPrice.UNIT_PRICE
      this.newUnitPrice.kdv = this.selectedUnitPrice.KDV
      this.newUnitPrice.period = this.selectedUnitPrice.PERIOD
      this.newUnitPrice.listId = this.selectedUnitPrice.LIST_ID
    },
  },
  mounted() {
    this.getUnitPrices()
  }
}
</script>

<style scoped>

  div.icon-global {
    position: absolute;
    z-index: 3;
    margin-left: -36px;
    margin-top: 24px;
    width: 30px;
    height: 30px;
    padding: 4px 4px 5px 4px;
    border-radius: 15px;
  }

  div.icon-global.bg-danger {
    margin-top: -6px !important;
  }

  div.icon-global i {
    color: #FFF;
  }

  .margin-negative {
    margin-bottom: -4px !important;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table { caption-side: top !important; }
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: 0.875rem;
  }

  td a.btn {
    font-size: .875rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

  .text-truncated {
    display: block !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/UnitPricesPage.vue